import {combineReducers} from "redux";
import {Statistics, PopularRanking} from "../../models/statistics";
import {Video} from "../../models/video";
import {AppAction} from "../../root/AppAction";
import ExVideoEvents from "../events/ExVideoEvents";

export interface ContextPhraseStore {
    phrases: string[];
    isLoading: boolean;
    errorMessage: string;
}

const initialContextPhraseStore: ContextPhraseStore = {
    phrases: [],
    isLoading: false,
    errorMessage: "",
};

export function contextPhrase(
    state: ContextPhraseStore = initialContextPhraseStore,
    action: AppAction
) {
    switch (action.type) {
        case ExVideoEvents.LoadAllContextPhraseStarted:
            return {
                ...state,
                isLoading: true,
           };

        case ExVideoEvents.LoadAllContextPhraseComplete:
            return {
                ...state,
                phrases: action.phrases,
                isLoading: false,
           };

        case ExVideoEvents.UpdateContextPhraseComplete:
            return {
                ...state,
                phrases: action.phrases,
                errorMessage: "",
           };

        case ExVideoEvents.UpdateContextPhraseFailed:
            return {
                ...state,
                errorMessage: action.error,
           };

        default:
            return state;
   }
}

export interface ProcessStatusStore {
    videos: Video[];
    isLoading: boolean;
}

const initialProcessStatusStore: ProcessStatusStore = {
    videos: [],
    isLoading: false,
};

export function processStatus(
    state: ProcessStatusStore = initialProcessStatusStore,
    action: AppAction
) {
    switch (action.type) {
        case ExVideoEvents.LoadProcessStatusStarted:
            return {
                ...state,
                isLoading: true,
           };

        case ExVideoEvents.LoadProcessStatusComplete:
            return {
                ...state,
                videos: action.videos,
                isLoading: false,
           };

        case ExVideoEvents.LoadProcessStatusRepeatStarted:
            return {
                ...state,
           };

        case ExVideoEvents.LoadProcessStatusRepeatComplete:
            return {
                ...state,
                videos: action.videos,
           };

        default:
            return state;
   }
}
export interface CaptionStore {
    isLoading: boolean;
    isEditSTT: boolean;
    isSuccessEditSTT: boolean;
    isFailedEditSTT: boolean;
    isRerunSTT: boolean;
    isSuccessRerunSTT: boolean;
    isFailedRerunSTT: boolean;
    isUpdatePublicStateStt: boolean;
    isSuccessUpdatePublicStateStt: boolean;
    isFailedUpdatePublicStateStt: boolean;
    errorMessage: string;
}

const initialCaptionStore: CaptionStore = {
    isLoading: false,
    isEditSTT: false,
    isSuccessEditSTT: false,
    isFailedEditSTT: false,
    isRerunSTT: false,
    isSuccessRerunSTT: false,
    isFailedRerunSTT: false,
    isUpdatePublicStateStt: false,
    isSuccessUpdatePublicStateStt: false,
    isFailedUpdatePublicStateStt: false,
    errorMessage: "",
};

export function caption(state: CaptionStore = initialCaptionStore, action: AppAction) {
    switch (action.type) {
        case ExVideoEvents.EditVideoCaptionStarted:
            return {
                ...state,
                isEditSTT: true,
                isSuccessEditSTT: false,
                isFailedEditSTT: false,
           };

        case ExVideoEvents.EditVideoCaptionComplete:
            return {
                ...state,
                isEditSTT: false,
                isSuccessEditSTT: true,
                errorMessage: "",
           };

        case ExVideoEvents.EditVideoCaptionFailed:
            // 編集完了メッセージ出すか検討
            return {
                ...state,
                isEditSTT: false,
                isFailedEditSTT: true,
                errorMessage: action.error,
           };

        case ExVideoEvents.RerunSTTStarted:
            return {
                ...state,
                isLoading: true,
                isRerunSTT: true,
                isSuccessRerunSTT: false,
                isFailedRerunSTT: false,
           };
        case ExVideoEvents.RerunSTTComplete:
            return {
                ...state,
                isLoading: false,
                isRerunSTT: false,
                isSuccessRerunSTT: true,
                errorMessage: "",
           };
        // VideoStoreも合わせて更新

        case ExVideoEvents.RerunSTTFailed:
            return {
                ...state,
                isLoading: false,
                isRerunSTT: false,
                isFailedRerunSTT: true,
                errorMessage: action.error,
           };

        case ExVideoEvents.UpdateCaptionPublicStateStarted:
            return {
                ...state,
                isLoading: true,
                isUpdatePublicStateStt: true,
                isSuccessUpdatePublicStateStt: false,
                isFailedUpdatePublicStateStt: false,
           };
        case ExVideoEvents.UpdateCaptionPublicStateComplete:
            return {
                ...state,
                isLoading: false,
                isUpdatePublicStateStt: false,
                isSuccessUpdatePublicStateStt: true,
                errorMessage: "",
           };
        // VideoStoreも合わせて更新

        case ExVideoEvents.UpdateCaptionPublicStateFailed:
            return {
                ...state,
                isLoading: false,
                isUpdatePublicStateStt: false,
                isFailedUpdatePublicStateStt: true,
                errorMessage: action.error,
           };

        default:
            return state;
   }
}

export interface VideoOptionStore {
    isLoading: boolean;
    isPlay: boolean;
    isVisibleCaption: boolean;
    isMuted: boolean;
    viewPattern: number;
}

const initialVideoOptionStore: VideoOptionStore = {
    isLoading: false,
    isPlay: true,
    isVisibleCaption: false,
    isMuted: false,
    viewPattern: 1,
};

export function videoOption(state: VideoOptionStore = initialVideoOptionStore, action: AppAction) {
    switch (action.type) {
        case ExVideoEvents.GetVideoOptionStarted:
            return {
                ...state,
                isLoading: true,
           };

        case ExVideoEvents.GetVideoOptionComplete:
            return {
                ...state,
                isLoading: false,
                isPlay: action.isPlay,
                isVisibleCaption: action.isVisibleCaption,
                isMuted: action.isMuted,
                viewPattern: action.viewPattern,
           };

        case ExVideoEvents.UpdateVideoOptionStarted:
            return {
                ...state,
                isLoading: true,
                isPlay: action.isPlay,
                isVisibleCaption: action.isVisibleCaption,
                isMuted: action.isMuted,
                viewPattern: action.viewPattern,
           };

        case ExVideoEvents.UpdateVideoOptionComplete:
            return {
                ...state,
                isLoading: false,
           };

        default:
            return state;
   }
}

export interface StatisticsStore {
    stats: Statistics;
    ranking: PopularRanking;
    isLoading: boolean;
}

const initialStatisticsStore: StatisticsStore = {
    stats: {viewCountList: [], playTimeList: [], userCountList: []},
    ranking: {popularVideoList: [], popularTagList: [], popularPeriodList: []},
    isLoading: false,
};

export function statistics(state: StatisticsStore = initialStatisticsStore, action: AppAction) {
    switch (action.type) {
        case ExVideoEvents.LoadStatisticsStarted:
            return {
                ...state,
                isLoading: true,
           };

        case ExVideoEvents.LoadStatisticsComplete:
            return {
                ...state,
                stats: action.stats,
                isLoading: false,
           };

        case ExVideoEvents.UpdateStatisticsStarted:
            return {
                ...state,
                errorMessage: "",
           };

        case ExVideoEvents.UpdateStatisticsComplete:
            return {
                ...state,
                errorMessage: "",
           };

        case ExVideoEvents.UpdateStatisticsFailed:
            return {
                ...state,
                errorMessage: action.error,
           };

        case ExVideoEvents.LoadPopularRankingStarted:
            return {
                ...state,
                isLoading: true,
           };

        case ExVideoEvents.LoadPopularRankingComplete:
            return {
                ...state,
                ranking: action.ranking,
                isLoading: false,
           };

        default:
            return state;
   }
}

export interface ExVideoStore {
    contextPhrase: ContextPhraseStore;
    processStatus: ProcessStatusStore;
    caption: CaptionStore;
    videoOption: VideoOptionStore;
    statistics: StatisticsStore;
}

export default combineReducers<ExVideoStore>({
    contextPhrase,
    processStatus,
    caption,
    videoOption,
    statistics,
});
